var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportAnalyticsShipmentV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21631 3.9082L8.58115 6.41673L12.946 3.9082",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58057 11.4331V6.41602",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3999 6.43945H4.1999",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 8.53906L4.19995 8.53906",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19995 3.90847C4.28801 3.75613 4.41458 3.62963 4.56697 3.54165L8.07891 1.53482C8.23145 1.44675 8.40448 1.40039 8.58061 1.40039C8.75675 1.40039 8.92978 1.44675 9.08232 1.53482L12.5943 3.54165C12.7466 3.62963 12.8732 3.75613 12.9613 3.90847C13.0493 4.06082 13.0958 4.23364 13.096 4.4096V8.42324C13.0958 8.59921 13.0493 8.77202 12.9613 8.92437C12.8732 9.07671 12.7466 9.20321 12.5943 9.2912L9.08232 11.298C8.92978 11.3861 8.75675 11.4325 8.58061 11.4325C8.40448 11.4325 8.23145 11.3861 8.07891 11.298L6.29995 10.2815",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalyticsShipmentV2);
export default __webpack_public_path__ + "static/media/reportAnalyticsShipmentV2.c9d6c2218e0496065559d8cd0f0f291a.svg";
export { ForwardRef as ReactComponent };